import $ from 'jquery';
import Globals from '../helpers/Globals';
import style from '../config/map-styling.json';

const { $body } = Globals;

const Map = {
    init() {
        if (!$('.js-google-map').length) return;

        this.initializeMap();
    },

    initializeMap() {
        const center = { lat: 52.132633, lng: 5.291266 };

        this.map = new google.maps.Map(document.getElementById('map'), {
            zoom: 15,
            center,
            mapTypeControlOptions: {
                mapTypeIds: ['sparc_map', 'hybrid'],
            },
        });

        const customStyle = new google.maps.StyledMapType(style, { name: 'Map' });

        this.map.mapTypes.set('sparc_map', customStyle);
        this.map.setMapTypeId('sparc_map');

        this.preLoadMapMarker();
        this.getMarkers();
    },

    getMarkers() {
        const $map = $('.map');
        const json = $map.data('json');
        const url = $map.data('url');

        if (typeof json !== 'undefined') {
            this.setMapMarkers(json);
        } else {
            $.ajax({
                url,
                type: 'GET',
                dataType: 'json',
            }).done(data => this.setMapMarkers(data.data));
        }
    },

    setMapMarkers(data) {
        this.bounds = new google.maps.LatLngBounds();
        this.markers = [];
        this.drawMarkers = [];

        const icon = '/img/markers/sparc-marker.svg';
        const scaledSize = new google.maps.Size(50, 55);

        this.infoWindow = new google.maps.InfoWindow({
            maxWidth: 400,
            pixelOffset: new google.maps.Size(0, -3),
        });

        data.forEach((markerData) => {
            const markerDataLatLng = new google.maps.LatLng(markerData.lat, markerData.lng);
            const marker = new google.maps.Marker({
                checked: false,
                position: markerDataLatLng,
                map: this.map,
                title: markerData.name,
                markerId: markerData.id,
                url: markerData.url,
                icon: {
                    url: icon,
                    scaledSize,
                },
            });

            this.setInfoWindow(markerData, marker);

            this.markers[marker.markerId] = marker;
            this.drawMarkers.push({ lat: markerData.lat, lng: markerData.lng });
            this.bounds.extend(markerDataLatLng);

            if (!data[1]) {
                this.openMarker(markerData, marker);
            }
        });

        this.setMapView(this.drawMarkers);
    },

    setInfoWindow(markerData, marker) {
        let title = '';
        let data = '';
        let realtimeData = '';
        let button = '';

        if (marker.title) {
            title = `<strong class="infowindow-title">${marker.title}</strong>`;
        }

        if (markerData.flood_data) {
            data = `<div class="infowindow-data">
                ${markerData.flood_data.map(flood => `
                    <div class="infowindow-data-row">
                        <div class="infowindow-data-col">
                            <svg class="icon icon-calendar"><use xlink:href="/svg/sprite.symbol.svg#calendar" href="/svg/sprite.symbol.svg#calendar"/></svg>
                            ${flood.date}
                        </div>
                        <div class="infowindow-data-col">
                            <svg class="icon icon-inflow-${flood.severity}"><use xlink:href="/svg/sprite.symbol.svg#inflow-${flood.severity}" href="/svg/sprite.symbol.svg#inflow-${flood.severity}"/></svg>
                        </div>
                        <div class="infowindow-data-col">
                            <svg class="icon icon-clock"><use xlink:href="/svg/sprite.symbol.svg#clock" href="/svg/sprite.symbol.svg#clock"/></svg>
                            ${flood.time}
                        </div>
                    </div>
                `).join('')}
            </div>`;
        }

        if (markerData.realtime_data) {
            realtimeData = `<div class="infowindow-data">
                ${markerData.realtime_data.map(realtime => `
                    <div class="infowindow-data-row">
                        <div class="infowindow-data-col">
                            ${realtime.name}
                        </div>
                        <div class="infowindow-data-col infowindow-value">
                            ${realtime.value}
                        </div>
                    </div>
                `).join('')}
            </div>`;
        }

        if (marker.url !== undefined) {
            button = `<div class="infowindow-data-row">
                <a class="button button-small" href="${marker.url}">Bekijken</a>
            </div>`;
        }

        marker.addListener('click', () => {
            this.infoWindow.setContent(title + data + realtimeData + button);
            this.infoWindow.open(this.map, marker);
        });
    },

    openMarker(markerData, marker) {
        let title = '';

        if (marker.title) {
            title = `<strong class="infowindow-title">${marker.title}</strong>`;
        }

        this.infoWindow.setContent(title);
        this.infoWindow.open(this.map, marker);
    },

    setMapView(markers) {
        if (markers.length > 1) {
            this.map.fitBounds(this.bounds);
        } else {
            this.map.setCenter(markers[0]);
            this.map.setZoom(15);
        }
    },

    preLoadMapMarker() {
        const myImage = new Image();

        myImage.src = '/img/markers/sparc-marker.svg';
        myImage.classList.add('hidden');

        $body.append(myImage);
    },
};

export default Map;
